import * as THREE from 'three';
import { getCurrentLang, getCurrentLangDirection, isDesktopMode } from '../language/langSwitcher';
import { isMobile, isTablet, projectMode, settingsData, threeJsVariables } from '../../settings';
import { CSS2DObject } from '../../libs/CSS2DRenderer';
import { createHtmlElement, Drag } from '../../functions';
import { BoxBufferGeometry } from 'three';
import { MeshBasicMaterial } from 'three';
import { Mesh } from 'three';
import { Raycaster } from 'three';
import { Vector3 } from 'three';
import { ViewMode } from '../../common';
import { getWorldData } from '../controls/orbitControls';
import {
  addCloseBtnInStreetView,
  addScripts,
  buildInfoWindowContent,
  buildInfoWindowMobileContent,
  checkPoiResponse,
  closePrevInfoWindow,
  dragEnd,
  dragStart,
  getPlacePhoto,
  getStreetPanorama,
  map,
  openMiniCard,
  openMiniCardFullscreen,
  openSnazzyInfoWindowHandler,
  resetMapRenderer,
  scriptsChecker,
  setMobileFullscreenCardSize,
  setMobileMiniCardSize,
  smoothlyAnimatePanTo,
  Swipe,
} from '../widgets/poi/poiv3';
import { Box3 } from 'three';
import { EdgesGeometry } from 'three';
import { DoubleSide } from 'three';
import { BackSide } from 'three';
import { showRightNavBar } from '../navigation/right-nav-bar';
import { checkMapPanoramaInOrbit } from './poi';
import { mobileBurgerStyleToggle, pageResize } from '../menu/menu';
import gsap from "gsap";
import {Draggable} from "gsap/Draggable";

let poiRaycaster = null;
let drag = null;
let swipe = null;
const poiIntersectionAnchor1 = [];
const poiIntersectionAnchor2 = [];

export function initPoiData (response) {
  if (!config.features.poi.active || projectMode.LiteMode.isActive() ){
    return;
  }
  const [poi,poiCategories,poiSettings] = response;
  const poiData = poi.data;
  const poiCategoriesData = poiCategories.data;
  const poiSettingsData = poiSettings.data;
  const hide = config.features.poi.hide;

  if (!checkPoiResponse(poiData,poiCategoriesData)) return;

  addPoiToCategory(poiCategoriesData,poiData, poiSettingsData);


  const scriptInterval = setInterval(async ()=>{
    addScripts();
    if (scriptsChecker() && map){
      clearInterval(scriptInterval);
      addPoiOnScene(poiCategoriesData);
    }
  },200);

  if (hide){
    poiRaycaster = new Raycaster();
    poiIntersectionAnchor1.push(...settingsData.objects_to_intersection);
    poiIntersectionAnchor2.push(...settingsData.objects_to_intersection);
  }
}

function addPoiOnScene (categories) {
  const poiGroup = new THREE.Group();
  poiGroup.name = 'Poi group';

  categories.forEach(category =>{
    const categoryColor = category.color;
    category.data.forEach(poi =>{
      if (poi.orbit === 1){
        const label = createPoiLabel(poi,categoryColor,category);
        poiGroup.add(label);
      }
    });
  });

 poiGroup.children.sort((prev,next) => prev.userData.order - next.userData.order);

  threeJsVariables.scene.add(poiGroup);

  animatePoi(poiGroup);

  poiIntersection();

  if (settingsData.activeViewMode !== ViewMode.Orbit){
    poiToggle(false);
  }
}

function animatePoi (group) {
  let count = 0.5;

  group.traverse(el =>{
    if (el.name === 'poi'){
      const line = el.getObjectByName('poi line');
      const label = el.getObjectByName('poi label');
      const tl = gsap.timeline();

      tl.fromTo(line.position,{
        y: -100
      },{
        y: line.position.y,
        onStart: () => {
          if (settingsData.activeModeSwitching || settingsData.activeViewMode !== ViewMode.Orbit){
            poiToggle(false);
          }
        },
        duration: count
      }).addLabel('lineAnimation');

      tl.to(label.element,{
        opacity: 1,
        duration: 0.2,
        onStart:() => {
          if (settingsData.activeModeSwitching || settingsData.activeViewMode !== ViewMode.Orbit){
            poiToggle(false);
          }
        },
        onComplete:()=>{
          label.element.style.opacity = '';
        }
      },'lineAnimation');

      count += 0.5;

    }
  });
}

function createPoiLabel (poi,categoryColor,category) {
  const hide = config.features.poi.hide;
  const poiGroup = new THREE.Group();
  poiGroup.name = 'poi';
  poiGroup.userData.distance = poi.distance;
  poiGroup.userData.order = poi.order;

  const lineMaterial = new THREE.LineBasicMaterial({color:0xffffff});
  const lineGeomerty = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(poi.coords3dScene.x, 0, poi.coords3dScene.z),
    new THREE.Vector3(poi.coords3dScene.x, poi.coords3dScene.y, poi.coords3dScene.z)
  ]);
  const line = new THREE.Line(lineGeomerty, lineMaterial);
  line.name = 'poi line';

  const name = poi.name.filter(el => el.lang === getCurrentLang())[0].value;
  const poiContainer = document.createElement('div');
  poiContainer.classList.add('poi__label');

  if (projectMode.LiteMode.isActive()){
    poiContainer.classList.add('lite-mode__line');
  }

  poiContainer.setAttribute('data-latitude', poi.latitude);
  poiContainer.setAttribute('data-longitude', poi.longitude);

  const poiText = createHtmlElement(poiContainer,name,'span',['poi__title','language-string']);
  poi.name.forEach(obj =>{
    poiText.setAttribute(`data-lang-${obj.lang}`, obj.value);
  });

  // poiContainer.style.backgroundColor = categoryColor;
  const placePhoto = getPlacePhoto(poi,{maxHeight: 255, maxWidth: 255});
  placePhoto.then(img =>{
    const mapMarker = settingsData.mapMarkers.allPoiMarkersWithoutCategory.filter(marker => marker.title === name)[0];
    mapMarker.data.sendPhotoRequest = true;
    const i = new Image();
    i.onload = ()=>{
      i.classList.add('poi__icon');
      poiContainer.appendChild(i);
      // poiContainer.style.backgroundImage = `url(${img})`;
      mapMarker.data.infoWindowImg = img;
    };
    i.onerror = () =>{
      const imgContainer = createHtmlElement(poiContainer,'','div',['poi__icon']);
      imgContainer.style.backgroundImage = `url(/img/icons/poi/${category.iconMenu}.svg)`;
      poiContainer.style.backgroundColor = categoryColor;
    };
    i.src = img;
  });

  const label = new CSS2DObject(poiContainer);
  label.name = 'poi label';
  label.material = new THREE.MeshBasicMaterial({color: 0xffffff});
  label.position.set(poi.coords3dScene.x,poi.coords3dScene.y,poi.coords3dScene.z);
  label.userData.zoom = 1;
  label.element.style.opacity = 0;

  if (hide){
    const anchorGeometry = new BoxBufferGeometry(40,40,40);
    const anchorMaterial = new MeshBasicMaterial({
      color: 0x000000,
      side: DoubleSide
    });

    const anchorMesh = new Mesh(anchorGeometry,anchorMaterial);
    anchorMesh.userData.poiLabel = label;
    anchorMesh.name = 'poi anchor';
    anchorMesh.position.set(poi.coords3dScene.x,poi.coords3dScene.y - 20,poi.coords3dScene.z);

    anchorMesh.geometry.computeBoundingBox();
    const boundingBox = anchorMesh.geometry.boundingBox;
    const center = anchorMesh.getWorldPosition(new Vector3());

    // const firstPoint = new Vector3().set(center.x + boundingBox.max.x,center.y / 2,center.z + boundingBox.max.z);
    // const secondPoint = new Vector3().set(center.x + boundingBox.max.x,center.y / 2,center.z + boundingBox.min.z);
    // // const secondPoint = new Vector3().set(center.x + boundingBox.min.x,center.y / 2,center.z + boundingBox.min.z);
    // // const secondPoint = new Vector3().set(center.x + boundingBox.min.x,center.y / 2,center.z + boundingBox.max.z);

    const firstPoint = new Vector3().copy(center).add(boundingBox.max).setY(center.y);
    const secondPoint = new Vector3().copy(center).add(boundingBox.min).setY(center.y);

    const poiAnchorGeometry = new BoxBufferGeometry(1,1,1);
    const poiAnchorMesh = new Mesh(poiAnchorGeometry,anchorMaterial);
    poiAnchorMesh.position.set(firstPoint.x,firstPoint.y,firstPoint.z);
    poiAnchorMesh.visible = false;
    poiAnchorMesh.name = 'poi anchor1';

    const secondPoiAnchorMesh = poiAnchorMesh.clone();
    secondPoiAnchorMesh.position.set(secondPoint.x,secondPoint.y,secondPoint.z);
    secondPoiAnchorMesh.name = 'poi anchor2';

    poiIntersectionAnchor1.push(poiAnchorMesh);
    poiIntersectionAnchor2.push(secondPoiAnchorMesh);
    poiGroup.add(poiAnchorMesh,secondPoiAnchorMesh);

    anchorGeometry.dispose();
    anchorMaterial.dispose();
    poiAnchorGeometry.dispose();
  }

  //

  // poiIntersectionArray1.push(anchorMesh);
  // poiGroup.add(anchorMesh);
  poiGroup.add(label);
  poiGroup.add(line);


  lineGeomerty.dispose();
  lineMaterial.dispose();

  return poiGroup;
}

function addPoiToCategory (categories,poiData,mainBuildingData) {
  const {startHeight,heightStep} = config.features.poi;
  let sizeY = startHeight;

  poiData.forEach(poi => {
    const {coords, distance} = calcPoiCoordsAndDistance(poi, mainBuildingData, 0);
    poi.coords3dScene = coords;
    poi.distance = distance;
  });

  poiData.sort((prev, next) => prev.distance - next.distance);

  poiData.forEach(poi => {
    poi.coords3dScene.y = sizeY;
    sizeY += heightStep;
  });

  categories.forEach(category => {
    category.data = [];
    poiData.forEach(poi => {
      if (Number(category.categoryId) === poi.categoryId) {
        category.data.push(poi);
      }
    });
  });
}

export function poiLineUpdate (visible = true) {
  const poiGroup = threeJsVariables.scene.getObjectByName('Poi group');
  poiGroup.traverse(el =>{
    if (el.name === 'poi line'){
      el.visible = visible;
    }
  });
}

export function cssPoiHandler (e) {
  let target = e.target;
  if (!config.features.poi.active){
    return;
  }

  if (target.classList.contains('poi__icon') || target.classList.contains('poi__title')){
    target = target.parentElement;
  } else if (!target.classList.contains('poi__label')){
    return;
  }

 if (target.classList.contains('hide__label')){
   return;
 }

  openMarkerInfoWindowInOrbit(target,e);

}

export function poiOrbitCardSwitchingLang () {
  const openedCard = document.querySelector('.poi__info-window');
  if (!openedCard){
    return;
  }

  const title = openedCard.getAttribute('data-poi-title');
  const poiLabel = document.querySelector(`.poi__title[data-lang-en="${title}"]`);
  const element = poiLabel.parentElement;

  openedCard.remove();

  const clickObj = {
    clientX: element.getBoundingClientRect().x,
    clientY: element.getBoundingClientRect().y
  };

  openMarkerInfoWindowInOrbit(element,clickObj);
}

function calcPoiCoords (poi,buildingPoi,poiY) {
  const poiLatitude = Number(poi.coords3d.x);
  const poiLongitude = Number(poi.coords3d.y);
  const latKmConstant = 111.134861111 * 1000;
  const lonKmConstant = (111.321377778 * Math.cos(poiLatitude)) * 1000;

  const {latitude,longitude} = buildingPoi;

  const posX = (latitude - poiLatitude) * latKmConstant;
  const posZ = (longitude - poiLongitude) * lonKmConstant;

  return new THREE.Vector3(posX,poiY,posZ);
}

function calcPoiCoordsAndDistance (poi, buildingPoi) {
  const poiLatitude = Math.abs(Number(poi.coords3d.x));
  const poiLongitude = Math.abs(Number(poi.coords3d.y));

  const mirror = config.features.poi.mirror;

  // const length = getLengthOfDegree({
  //   lat: poiLatitude,
  //   lng: poiLongitude
  // });

  // const latMeter = length.latKm * 1000;
  // const lngMeter = (length.lngKm * Math.cos(poiLatitude)) * 1000;

  const latKmConstant = 111.134861111 * 1000;
  const lonKmConstant = (111.321377778 * Math.cos(mirror ? poiLongitude : poiLatitude)) * 1000;

  let {latitude, longitude} = buildingPoi;

  const posX = (Math.abs(latitude) - poiLatitude) * latKmConstant;
  const posZ = (Math.abs(longitude) - poiLongitude) * lonKmConstant;
  const distance = new Vector3().distanceTo(new Vector3(posX,0,posZ));

  return {
    coords: new THREE.Vector3(posX, 0, posZ),
    distance: distance,
  };
}

// function getLengthOfDegree (coords) {
//   const length = {};
//
//   // Latitude
//   if (coords.lat > 0 && coords.lat < 15){
//     length.latKm = 110.574;
//   } else if (coords.lat >= 15 && coords.lat < 30){
//     length.latKm = 110.649;
//   } else if (coords.lat >=30 && coords.lat < 45){
//     length.latKm = 110.852;
//   } else if (coords.lat >=45 && coords.lat < 60){
//     length.latKm = 111.133;
//   } else if (coords.lat >=60 && coords.lat < 75){
//     length.latKm = 111.412;
//   } else if (coords.lat >=75 && coords.lat < 90){
//     length.latKm = 111.618;
//   } else if (coords.lat >=90){
//     length.latKm = 111.694;
//   }
//
//   // Longitude
//   if (coords.lng > 0 && coords.lng < 15){
//     length.lngKm = 111.320;
//   } else if (coords.lng >=15 && coords.lng < 30){
//     length.lngKm = 107.551;
//   } else if (coords.lng >=30 && coords.lng < 45){
//     length.lngKm = 96.486;
//   } else if (coords.lng >=45 && coords.lng < 60){
//     length.lngKm = 78.847;
//   } else if (coords.lng >=60 && coords.lng < 75){
//     length.lngKm = 55.800;
//   } else if (coords.lng >=75 && coords.lng < 90){
//     length.lngKm = 28.902;
//   } else if (coords.lng >=90){
//     length.lngKm = 0;
//   }
//
//   return length;
// }

const firstPoiAnchor = new Vector3();
const secondPoiAnchor = new Vector3();

export function poiIntersection () {
  if (!config.features.poi.active || !config.features.poi.hide || projectMode.LiteMode.isActive()){
    return;
  }
  const group = threeJsVariables.scene.getObjectByName('Poi group');
  if (!group || settingsData.activeViewMode !== ViewMode.Orbit){
    return;
  }

  if (!group.visible){
    return;
  }

  group.traverse(el =>{
    if (el.name === 'poi'){

      let show1, show2;

      const firstAnchor = el.getObjectByName('poi anchor1');
      const secondAnchor = el.getObjectByName('poi anchor2');
      const label = el.getObjectByName('poi label');
      const line = el.getObjectByName('poi line');

      firstAnchor.getWorldPosition(firstPoiAnchor);

      firstPoiAnchor.project(threeJsVariables.perspectiveCamera);
      poiRaycaster.setFromCamera(firstPoiAnchor,threeJsVariables.perspectiveCamera);

      const intersects = poiRaycaster.intersectObjects(poiIntersectionAnchor1);
      show1 = Boolean(intersects.length && firstAnchor === intersects[0].object);

      if (show1){
        secondAnchor.getWorldPosition(secondPoiAnchor);

        secondPoiAnchor.project(threeJsVariables.perspectiveCamera);
        poiRaycaster.setFromCamera(secondPoiAnchor,threeJsVariables.perspectiveCamera);
        const intersects2 = poiRaycaster.intersectObjects(poiIntersectionAnchor2);
        show2 = Boolean(intersects2.length && secondAnchor === intersects2[0].object);
      }


      if (show1 && show2){
        line.visible = true;
        label.element.classList.remove('hide__label');
      } else {
        line.visible = false;
        label.element.classList.add('hide__label');
      }
      // label.visible = !!(show1 && show2);
      // line.visible = !!(show1 && show2);
    }

  });

}

export function poiToggle (visible) {
  if (!config.features.poi.active){
    return;
  }
  const group = threeJsVariables.scene.getObjectByName('Poi group');

  if (!group){
    return;
  }

  // if (group.visible === visible){
  //   return;
  // }

  group.traverse(el =>{
    if (el.name !== 'poi anchor1' && el.name !== 'poi anchor2'){
      el.visible = visible;
    }
  });

  visible && poiIntersection();
}

export function openMarkerInfoWindowInOrbit (element,e) {
  const title = element.querySelector('.poi__title').getAttribute('data-lang-en');
  const poiName = element.textContent;
  const poiImg = element.querySelector('.poi__icon');
  const poiData = config.poiData.find(poi => poi.name.find(name => name.value === poiName));
  const poiMarker = settingsData.mapMarkers.allPoiMarkersWithoutCategory.filter(marker => marker.title === poiName)[0];
  let infoCardContainer;

  const infoWindow = document.querySelector('.poi__info-window');
  infoWindow && closePoiInfoWindowCardInOrbit();

  const mainContainer = createHtmlElement(document.body,'','div',['poi__info-window']);
  mainContainer.setAttribute('data-poi-title',title);

  if (poiImg.tagName !== 'DIV'){
    poiMarker.data.infoWindowImg = poiImg.src;
  }

  if (isMobile){
    infoCardContainer = buildInfoWindowMobileContent(poiMarker,true);
    addLanguageContent(infoCardContainer,poiData);
    mainContainer.appendChild(infoCardContainer);
    swipe = new Swipe(mainContainer);
    setPoiCardSwipeFunctions(swipe,poiMarker,mainContainer);

    setTimeout(()=>{
      openMiniCard(mainContainer,false,true);
    },100);

  } else {
    infoCardContainer = buildInfoWindowContent(poiMarker,true);
    addLanguageContent(infoCardContainer,poiData);
    mainContainer.appendChild(infoCardContainer);
    calculateAndSetCardPosition(mainContainer,e);
    poiCardAnimation('open');
    const poiDrag = new Drag(mainContainer,{
      updateElementPositionAfterDragEnd: true,
      touchSupport: true
    });
  }
}

export function resizeOrbitPoiCard () {
  if (!isMobile){
    return;
  }
  const card = document.querySelector('.poi__info-window');
  if (!card){
    return;
  }
  if (!settingsData.isLandscape && !card.classList.contains('orbit__mode')){
    card.firstElementChild.style.maxWidth = 'unset';
    card.firstElementChild.style.width = '100%';
  }
  const poiMarker = settingsData.mapMarkers.allPoiMarkersWithoutCategory.filter(marker => marker.title === card.getAttribute('data-poi-title'))[0];

  if (card.classList.contains('orbit__mode')){
    setMobileFullscreenCardSize(true);
  } else {
    openMiniCard(card,false,true);
  }
  setPoiCardSwipeFunctions(swipe,poiMarker,card);
}

export function setActiveRouteInOrbitCard (route) {
  const orbitCard = document.querySelector('.poi__info-window');
  if (orbitCard){
    const routeContainer = orbitCard.querySelector(`.route[data-route-type="${route}"]`);
    routeContainer && routeContainer.classList.add('active-route');
  }
}

export function resetOrbitActiveRoute () {
  const orbitCard = document.querySelector('.poi__info-window');
  if (orbitCard){
    const activeOrbitRoute = orbitCard.querySelector('.route.active-route');
    activeOrbitRoute && activeOrbitRoute.classList.remove('active-route');
  }
}

function addLanguageContent (element,poiData) {
  const category = config.poiCategories.filter(category => parseInt(category.categoryId) === poiData.categoryId)[0];
  const categoryTitle = element.querySelector('.snazzy-content__category-title');
  const times = element.querySelectorAll('.snazzy-content__time-route');
  const streetView = element.querySelector('.snazzy-content__street-view');
  const title = element.querySelector('.snazzy-content__title');
  const description = element.querySelector('.snazzy-content__description');
  const address = element.querySelector('.snazzy-content__address');

  categoryTitle.classList.add('language-string');
  categoryTitle.setAttribute('data-dictionary',category.name.filter(name => name.lang === 'en')[0].value);

  streetView.classList.add('language-string');
  streetView.setAttribute('data-dictionary',config.dictionary['Street view'].en);

  title.classList.add('language-string');
  address.classList.add('language-string');
  description.classList.add('language-string');

  poiData.name.forEach(obj =>{
    title.setAttribute(`data-lang-${obj.lang}`, obj.value);
  });

  poiData.address.forEach(obj =>{
    address.setAttribute(`data-lang-${obj.lang}`, obj.value);
  });

  poiData.description.forEach(obj =>{
    description.setAttribute(`data-lang-${obj.lang}`, obj.value);
  });

  for (let time of times){
    time.classList.add('language-string');
    time.setAttribute('data-dictionary-parse','mins');
  }
}

function calculateAndSetCardPosition (container,event) {
  let left, top;

  const direction = getCurrentLangDirection();

  let menuWidth = 0;
  const asideMenuWidth = document.querySelector('.aside__container');
  if (asideMenuWidth){
    menuWidth = parseFloat(asideMenuWidth.dataset.initialWidth);
  }

  const width = container.getBoundingClientRect().width;
  const height = container.getBoundingClientRect().height;
  const halfCardWidth = width / 2;
  const halfCardHeight = height / 2;
  const eventX = event.clientX;
  const eventY = event.clientY;
  const cardCenterX = eventX - halfCardWidth;
  const cardCenterY = eventY - halfCardHeight;

  const windowSize = {
    minX: (direction === 'ltr') ? menuWidth : 0,
    maxX: (direction === 'ltr') ? window.innerWidth: window.innerWidth - menuWidth,
    minY: 0,
    maxY: window.innerHeight
  };

  const cardSize = {
    minX : eventX - halfCardWidth,
    maxX : eventX + halfCardWidth,
    minY : eventY - halfCardHeight,
    maxY : eventY + halfCardHeight
  };

  if (cardSize.minX < windowSize.minX){
    left = windowSize.minX;
  } else if (cardSize.maxX > windowSize.maxX){
    left = windowSize.maxX - width;
  } else {
    left = cardCenterX;
  }


  if (cardSize.minY < windowSize.minY){
    top = windowSize.minY;
  } else if (cardSize.maxY > windowSize.maxY){
    top = windowSize.maxY - height;
  } else {
    top = cardCenterY;
  }

  container.style.left = left + 'px';
  container.style.top = top + 'px';

  console.log(left)

  container.setAttribute('clickX',cardCenterX);
  container.setAttribute('clickY',cardCenterY);
  container.setAttribute('initialLeft',left);
  container.setAttribute('initialTop',top);
}

export function closePoiInfoWindowCardInOrbit (smoothClose = false,returnMapToBuilding = true) {
  if (settingsData.activeViewMode !== ViewMode.Orbit){
    return;
  }
  const mainContainer = document.querySelector('.poi__info-window');
  if (!mainContainer){
    return;
  }

  if (isMobile){
    mainContainer.classList.remove('open-mobile-card');
    if (smoothClose){
      setTimeout(()=>{
        mainContainer.remove();
        mobileBurgerStyleToggle();
        resetMapRenderer();
        returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
      },200);
    } else {
      mainContainer.remove();
      mobileBurgerStyleToggle();
      resetMapRenderer();
      returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
    }
  } else {
    if (smoothClose){
      poiCardAnimation('close');
      setTimeout(()=>{
        mainContainer.remove();
        resetMapRenderer();
        returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
      },200);
    } else {
      mainContainer.remove();
      resetMapRenderer();
      returnMapToBuilding && smoothlyAnimatePanTo(map, settingsData.mapCenter);
    }
  }
  closePrevInfoWindow();
}

export function setPoiCardSwipeFunctions (classVariable,...args) {

  const dir = getCurrentLangDirection();
  classVariable.stop();
  if (!settingsData.isLandscape){
    classVariable.onDown(()=>{
      console.log('down')
      closePoiInfoWindowCardInOrbit(true)
    });
    classVariable.onUp(()=> {
      openMiniCardFullscreen(args[0],true);
      args[1].classList.add('orbit__mode');
      mobileBurgerStyleToggle();
      classVariable.onDown = ()=>{};
    });

  } else {

    switch (dir) {
      case 'rtl':
        classVariable.onLeft(() => closePoiInfoWindowCardInOrbit(true));
        classVariable.onRight(()=>{
          openMiniCardFullscreen(args[0],true);
          args[1].classList.add('orbit__mode');
          mobileBurgerStyleToggle();
          classVariable.onDown = ()=>{};
        });
        break;
      case 'ltr':
        classVariable.onRight(() => closePoiInfoWindowCardInOrbit(true));
        classVariable.onLeft(()=>{
          openMiniCardFullscreen(args[0],true);
          args[1].classList.add('orbit__mode');
          mobileBurgerStyleToggle();
          classVariable.onDown = ()=>{};
        });
        break;
    }

  }

  classVariable.run();
}

function poiCardAnimation (action) {
  const card = document.querySelector('.poi__info-window');
  if (!card){
    return;
  }

  let left = isDesktopMode() ? window.innerWidth - card.getBoundingClientRect().width - 37 : getCurrentLangDirection() === 'ltr' ? window.innerWidth - card.getBoundingClientRect().width - 37 : 37;

  switch (action) {
    case 'open':
      gsap.fromTo(card,{
        transform: 'scale(0)',
        left: card.getAttribute('clickX'),
        top: card.getAttribute('clickY')
      },{
        left: left,
        // left: card.getAttribute('initialLeft'),
        // top: card.getAttribute('initialTop'),
        top: 110,
        transform: 'scale(1)',
        duration: .2,
        delay: 0,
      });
      break;
    case 'close':
      gsap.to(card,{
        duration: .2,
        delay: 0,
        left: card.getAttribute('clickX'),
        top: card.getAttribute('clickY'),
        transform: 'scale(0)'
      });
      break;
  }
}

export function updateMapPanoramaInOrbit () {
  const container = document.querySelector('.map__panorama__orbit');
  if (!container){
    return;
  }

  pageResize(container);
}

